import * as api from "Api";
import * as actions from "Actions";

export const fetchCollaboratorsCalendar = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    const {
      collaborator,
      year,
      zones,
      squads
    } = getState().calendarTable.filter;
    const {
      filter: { clientCRMTypes, clientCRMGroup }
    } = getState().financialSheet.periodTree;
    const {
      entityClientId: { deletedStatus }
    } = getState().clients.filter;
    dispatch(
      actions.fetchCollaboratorsCalendar(
        api
          .getCollaboratorsCalendar(
            currentOrganization.id,
            collaborator.selected,
            year.selected.length > 0
              ? year.selected
              : [new Date().getFullYear().toString()],
            squads.selected,
            zones.selected,
            clientCRMTypes,
            clientCRMGroup,
            deletedStatus
          )
          .then(res => {
            return res.data.data;
          })
      )
    );
  };
};

export const fetchCollaboratorsSynthesis = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    const { year, zones, squads } = getState().calendarTable.filter;
    const {
      filter: { clientCRMTypes, clientCRMGroup }
    } = getState().financialSheet.periodTree;
    const {
      entityClientId: { deletedStatus }
    } = getState().clients.filter;

    dispatch(
      actions.fetchCollaboratorsSynthesis(
        api
          .getCollaboratorsSynthesis(
            currentOrganization.id,
            year.selected.length > 0
              ? year.selected
              : new Date().getFullYear().toString(),
            squads.selected,
            zones.selected,
            clientCRMTypes,
            clientCRMGroup,
            deletedStatus
          )
          .then(res => {
            return res.data.data;
          })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/collaborator-calendar.js